
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Input, Label } from 'reactstrap';
import Textarea from '@mui/joy/Textarea';
import TextInput from '../components/TextInput';
import SelectInput from '../components/SelectInput';
import LabelField from '../components/LabelField';
import { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from "react-hook-form"
import { useDispatch, useSelector } from 'react-redux';
import { FormUtils } from '../utils/FormUtils';
import { getValue } from '@testing-library/user-event/dist/utils';
import { createGrievanceApi, docUploadApi, getDistrictsApi, getLocationDataApi, getGrievanceDescriptionsApi, policyDetailsSearchApi, docsUploadApi } from '../api/grievancesApi';
import { ColumnHeaderType, LoggedUserType } from '../utils/Types';
import { loginSelector } from "../redux/slices/loginSlice";
import { handleCreateGrievanceSlice, handleLocationDataSlice } from '../redux/slices/grievancesSlice';
import { toast } from 'react-toastify';
import { checkNullValue, filterProducts, getCurrentDate, getCurrentTime, getDepartmentData, getGrievanceTypeData, getIdByValue, getLobData, getProductData } from '../utils/Util';
import TableComponent from '../components/TableComponent';
import { CLICK_ACTIONS, LINE_OF_BUSINESS, ROLE_ID, MAX_ATTACHMENT_SIZE, MIN_DATE_INTIMATION, STATUS } from '../utils/Constant';
import { mapMasters, mapLOBMaster, mapGrievanceModeMaster, mapGrievanceTypeMaster } from '../utils/MastersMapping';
import { getAllUsersByDepartment } from '../api/roleMasterApi';
import { CLAIM_DETAILS_HEADERS, PMFBY_CLAIM_DETAILS_HEADERS, POLICY_DETAILS_HEADERS, PROPOSAL_DETAILS_HEADERS } from '../pages/dashboard/DashboardHelper';
import YearPicker from '../components/YearPicker';
import TextAreaInput from '../components/TextAreaInput';

interface ViewData {
    createdDate: Date | undefined;
    turnAroundTime: Date | undefined;
    complaintSource: string;
    complaintMode: string;
    grievanceType: string;
    claimId: string;
    grievanceId: string;
    policyNumber: string;
    applicationNumber: string;
    department: string;
    spoc: string;
    status: string;
    name: string;
    mobileNumber: string;
    refno: string;
    description: string;
    remarks: string;
    emailId: string;
    pincode: string;
    city: string;
    state: string;
    surveyNumber: string;
    subSurveyNumber: string;
    checkBox: boolean;
    intimationDate: string;
    intimationTime: string;
    typeOfRequest: string;
    typeOfGrievanceDescription: string | number | undefined;
    additionalInfo: {};
    crop: string;
    product: string;
    season: string;
    year: string;
}

const NewGrievance = (props: any) => {
    const { toggle, openModal } = props
    const [submitData, setSubmitData] = useState<ViewData>();
    const user: LoggedUserType = useSelector(loginSelector).user;
    const userName = user?.employeeName.split(':')[0]
    const [selectedStateId, setSelectedStateId] = useState<any>(-1)
    const [selectedDistrictId, setSelectedDistrictId] = useState<any>(-1)
    const [checkbox, setCheckbox] = useState<boolean>(false);
    const [grievanceTypeSearch, setGrievanceTypeSearch] = useState<boolean>(true);
    const [showPolicyDetails, setShowPolicyDetails] = useState<boolean>(false);
    const [showTable, setShowTable] = useState<boolean>(false);
    const [columnHeaders, setColumnHeaders] = useState<any>();
    const [searchValue, setSearchValue] = useState<string>('');
    const [searchClicked, setSearchClicked] = useState<boolean>(false);
    const [pincodePopulated, setPincodePopulated] = useState<boolean>(false);
    const [productPopulated, setProductPopulated] = useState<boolean>(false);
    const [seasonPopulated, setSeasonPopulated] = useState<boolean>(false);
    const [yearPopulated, setYearPopulated] = useState<boolean>(false);
    const [cropPopulated, setCropPopulated] = useState<boolean>(false);
    const [spocList, setSpocList] = useState<any>([]);
    const [departmentList, setDepartmentList] = useState<any>([{value: 1, label: 'GRO'}]);
    const [isNameEditable, setIsNameEditable] = useState<boolean>(true);
    const [isMobileNumberEditable, setIsMobileNumberEditable] = useState<boolean>(true);

    const data = useForm<ViewData>({
        defaultValues: {
            createdDate: undefined,
            turnAroundTime: undefined,
            complaintSource: '',
            complaintMode: '',
            grievanceType: '',
            claimId: '',
            grievanceId: '',
            policyNumber: '',
            department: '',
            spoc: '',
            status: '',
            name: '',
            mobileNumber: '',
            refno: '',
            description: '',
            remarks: '',
            emailId: '',
            pincode: '',
            city: '',
            state: '',
            surveyNumber: '',
            subSurveyNumber: '',
            checkBox: false,
            intimationDate: '',
            intimationTime: '',
            typeOfRequest: '',
            typeOfGrievanceDescription: '',
            applicationNumber: '',
            crop: '',
            product: '',
            season: '',
            additionalInfo: {},
            year: '',
        },
        mode: 'all',
    });

    const closeBtn = (
        <img src={require('../assets/img/close_modal.svg').default} onClick={() => { toggle(); props.setFlag(false) }} style={{ cursor: 'pointer' }}></img>
    );

    const {
        storeUserListByDepartment
    } = useSelector((state: any) => state.roleMaster);
    const {
        storeGrievanceTypeData,
        storeComplaintSourceData,
        storeComplaintModeData,
        storeDepartmentData,
        storeCreateGrievanceData,
        storeStateMasterData,
        storeDistrictMasterData,
        storeLocationData,
        storeCustomerDetailsSearchData,
        storePolicyDetailsSearchData,
        storeGrievanceDescriptionData,
        storeSearchData,
        storeRequesTypeData,
        selectedApplication,
        storeProductData,
        storeSeasonData,
        storeLOBData,
    } = useSelector((state: any) => state.grievances);

    const grievanceTypeData = getGrievanceTypeData(FormUtils.convertDataList(
        storeGrievanceTypeData?.data ?? []
    ))

    const seasonData = FormUtils.convertDataList(
        storeSeasonData?.data ?? []
    )

    const complaintSourceData = FormUtils.convertDataList(
        storeComplaintSourceData.data ?? []
    );

    const complaintModeData = FormUtils.convertDataList(
        storeComplaintModeData.data ?? []
    );

    const departmentData = getDepartmentData(
        storeDepartmentData.data ?? []
    );

    const lobList = getLobData(FormUtils.convertDataList(
        storeLOBData?.data ?? []
    ))

    const stateData = FormUtils.convertDataList(
        storeStateMasterData.data ?? []
    );

    const districtData = FormUtils.convertDataList(
        storeDistrictMasterData.data ?? []
    );

    const typeOfRequestData = FormUtils.convertDataList(
        storeRequesTypeData.data ?? []
    );

    const typeOfGrievanceDescData = FormUtils.convertDataList(
        storeGrievanceDescriptionData.data ?? []
    );

    const productData = filterProducts(getProductData(
        storeProductData.data ?? []
    ), storeSearchData?.lineOfBusiness);

    const customerData = storeCustomerDetailsSearchData?.data ?? []

    const locationData = storeLocationData ?? {}

    const createGrievanceResponse = storeCreateGrievanceData ?? {}

    const policyDetails = storePolicyDetailsSearchData ?? {}

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors },
    } = useForm<ViewData>()

    const dispatch: any = useDispatch()

    const onSubmit = (data: ViewData) => {
        let intimation_date = data.intimationDate?.length > 0 ? data.intimationDate : getCurrentDate()
        let intimation_time = data.intimationTime?.length > 0 ? data.intimationTime : getCurrentTime()
        let createdAt = `${intimation_date}T${intimation_time}:00`;
        const date: Date = new Date(createdAt);
        const formattedDate: string = date.toISOString().replace('Z', '+00:00');

        let complaintDescriptionId = typeOfGrievanceDescData?.find((obj: any) => obj?.label === data?.typeOfGrievanceDescription)?.value;
        let submitData = { ...data, createdAt: formattedDate, lob: storeSearchData?.lineOfBusiness, typeOfGrievanceDescription: complaintDescriptionId }

        setSubmitData(submitData);

        const payload = {
            description: submitData.description?.trim() === '' ? '' : submitData.description?.trim(),
            claimId: submitData.claimId?.trim() === '' ? '' : submitData.claimId?.trim(),
            policyNumber: submitData.policyNumber?.trim(),
            status: STATUS.NEW,
            integrationSource: 1,
            grievanceTypeId: mapGrievanceTypeMaster(submitData.grievanceType),
            grievanceSource: submitData.complaintSource ? mapMasters(submitData.complaintSource, complaintSourceData) : 3,
            grievanceMode: submitData.complaintMode?.length > 0 ? mapMasters(submitData.complaintMode, complaintModeData) : 20,
            referenceId: submitData.refno?.trim() === '' ? '' : submitData.refno?.trim(),
            spoc: submitData.spoc,
            department: submitData.department ? mapMasters(submitData.department, departmentData) : 14,
            createdBy: userName,
            lineOfBussiness: mapMasters(submitData.lob, lobList),
            applicationNumber: submitData?.applicationNumber?.trim(),
            cropName: submitData?.crop?.trim(),
            product: mapMasters(submitData.product?.trim(), productData),
            season: submitData?.season?.trim(), 
            year: submitData?.year?.trim(),       
            additionalInfo: submitData.additionalInfo, 
            grievanceRequesterRequest: {
                // requesterId : null,
                email: submitData.emailId ? submitData.emailId?.trim() : null,
                mobileNumber: submitData.mobileNumber?.trim(),
                name: submitData.name?.trim(),
            },
            grievanceAddressRequest: {
                // addressId : null,
                pincode: submitData.pincode ? submitData.pincode?.trim() : null,
                address1: submitData.city ? submitData.city?.trim() : null,
                address2: submitData.state ? submitData.state?.trim() : null,
                districtId: selectedDistrictId ? selectedDistrictId : null,
                stateId: selectedStateId ? selectedStateId : null,
                villageId: null
            },
            remarks: submitData.remarks?.trim() === '' ? '' : submitData.remarks?.trim(),
            createdAt: (submitData?.intimationDate?.length > 0 && submitData?.intimationTime?.length > 0 )? submitData?.createdAt : '',
            typeOfRequest: submitData?.typeOfRequest ? mapMasters(submitData.typeOfRequest, typeOfRequestData) : 1,
            complaintDescriptionId: submitData?.typeOfGrievanceDescription ? submitData.typeOfGrievanceDescription : '',
        };  
        dispatch(createGrievanceApi(payload))
    };

    useEffect(() => {
        if (createGrievanceResponse?.statusId === 'OK') {
            const grievanceId = createGrievanceResponse?.data?.grievanceId;
            const onUploadSuccess = () => {
            props.setFlag(true);
            toggle();
            dispatch(handleCreateGrievanceSlice(''));
            };
        if (Array.isArray(image) && image.length > 0) {
        dispatch(docsUploadApi(grievanceId, image, mapGrievanceModeMaster(submitData?.complaintMode) === 2 ? submitData?.refno : '', false, onUploadSuccess));
        } else {
        onUploadSuccess();
        }
    }
}, [storeCreateGrievanceData]);

    const onChangeInput = (label: any, value: any,) => {
        setValue(label, value, { shouldValidate: true });
    }

    const handleYearChange = (value: any, label: any) => {
        setValue(label, value?.format('YYYY'), { shouldValidate: true });
    }

    const pincode = watch('pincode')
    const state = watch('state')
    const district = watch('city')
    useEffect(() => {
        if(!pincodePopulated){
            if (pincode?.length === 6) {
                dispatch(getLocationDataApi(pincode))
            }
            else {
                dispatch(handleLocationDataSlice({}))
            }
        }
        else{
            dispatch(handleLocationDataSlice({}))            
            setPincodePopulated(false)
        }
    }, [pincode])

    useEffect(() => {
        if(!pincodePopulated){
            if (Object.keys(locationData).length > 0 && (typeof locationData !== 'string')) {
                setValue('state', locationData?.data[0]?.state)
                setValue('city', locationData?.data[0]?.district)
            }
            else {
                setValue('state', '')
                setValue('city', '')
            }
        }
    }, [locationData])

    useEffect(() => {
        const stateId = getIdByValue(state, stateData)
        setSelectedStateId(stateId)
    }, [state])

    useEffect(() => {
        const districtId = getIdByValue(district, districtData)
        setSelectedDistrictId(districtId)
    }, [district])

    useEffect(() => {
        if (selectedStateId > 0) {
            dispatch(getDistrictsApi(selectedStateId))
        }
    }, [selectedStateId])


    const [image, setImage] = useState<any[]>([]);
    const setFile = (e: any) => {
    const files: File[] = Array.from(e.target.files || []);
        if (!files.length) return;

        const MAX_SIZE = 10 * 1024 * 1024;
        const validTypes = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const validExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'msg', 'eml','doc','docx','xls','xlsx'];

    files.forEach((file) => {
        if (file.size > MAX_SIZE) {
        toast.warn(`${file.name} exceeds 10MB limit`);
        return;
        }

        const lastDotIndex = file.name.lastIndexOf('.');
        const fileExtension =lastDotIndex !== -1 ? file.name.substring(lastDotIndex + 1).toLowerCase() : '';

        if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
        toast.warn(`Invalid file type: ${file.name}`);
        return;
        }
        const reader = new FileReader();

        reader.onloadend = () => {
        const base64String = reader.result as string;

        if (!base64String || !base64String.includes(',')) {
            toast.warn(`Invalid file data: ${file.name}`);
            return;
        }

        setImage(prev => [...prev,
            {
            imageName: file.name,
            imageSize: file.size,
            imageType: fileExtension,
            imageBase64: base64String.split(',')[1]
            }
        ]);
        };
        reader.readAsDataURL(file);
    });

    e.target.value = '';
    }

    const [modeOfComplaintData, setModeOfComplaintData] = useState(complaintModeData)
    const grievanceSource = watch('complaintSource');

    useEffect(() => {
        if (grievanceSource === 'InDirect') {
            setValue('complaintMode','')
            let modeData = complaintModeData.filter((each: any) => {
                if (each.value < 5 || each.value == 16 || each.value == 18 || each.value == 17 || each.value == 22) { return each }
            })
            setModeOfComplaintData(modeData)
        }
        else if (grievanceSource === 'Direct') {
            setValue('complaintMode','')
            let modeData = complaintModeData.filter((each: any) => {
                if ((each.value > 4 && each.value < 16) || each.value == 19 || each.value == 23) { return each }
            })
            setModeOfComplaintData(modeData)
        }
        else if(grievanceSource === 'To Be Assigned'){
            let modeData = complaintModeData.filter((each: any) => {
                if (each.value === 20) { return each }
            })
            setModeOfComplaintData(modeData)
            setValue('complaintMode','To Be Assigned')
        }
    }, [grievanceSource])

    const handleSelect = (event: any) => {
        setCheckbox(event.target.checked)
        if (!event.target.checked) {
            setValue('surveyNumber', '')
            setValue('subSurveyNumber', '')
        }
    }

    const handleTimeChange = (e: any) => {
        let inputValue = e.target.value;
        let currentDateValue = getValues('intimationDate');
        let currentTime = getCurrentTime();
        let currentDateString = getCurrentDate();

        if (currentDateString === currentDateValue && inputValue > currentTime) {
            e.target.value = undefined;
            toast.warn('You cannot select future time.');
        }
        else {
            setValue('intimationTime', e.target.value, { shouldValidate: true })
        }
    }

    let intimationDate = watch('intimationDate')
    useEffect(() => {
        setValue('intimationTime', '')
    }, [intimationDate])


    const grievanceType = watch('grievanceType');

    const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
        if (headerItem.action === CLICK_ACTIONS.SELECT_CLAIM) {
            setValue('claimId', each?.claimNumber)
            if(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                setValue('policyNumber', each?.policyNumber)
            }
            setValue('crop', each.crop)
            setValue('product', each.product)
            setValue('season', each.season)
            setValue('year', each.quotationDate)
            setShowPolicyDetails(true)
            setShowTable(false)
        } else if (headerItem.action === CLICK_ACTIONS.SELECT_PROPOSAL) {
            setValue('claimId', '')
            if(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                setValue('policyNumber', '')
            }
            setValue('crop', each.crop)
            setValue('product', each.product)
            setValue('season', each.season)
            setValue('year', each.quotationDate)
            setShowPolicyDetails(true)
            setShowTable(false)
        } else if (headerItem.action === CLICK_ACTIONS.SELECT_POLICY) {
            if(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                setValue('policyNumber', each?.policyNumber)
            }
            setValue('claimId', '')
            setValue('crop', each.crop)
            setValue('product', each.product)
            setValue('season', each.season)
            setValue('year', each.quotationDate)
            setShowPolicyDetails(true)
            setShowTable(false)
        }
        each?.crop ? setCropPopulated(true) : setCropPopulated(false);
        each?.product ? setProductPopulated(true) : setProductPopulated(false);
        each?.season ? setSeasonPopulated(true) : setSeasonPopulated(false);
        each?.quotationDate ? setYearPopulated(true) : setYearPopulated(false);
        setValue('additionalInfo', each)
        setValue('additionalInfo', {...getValues('additionalInfo'), lob: storeSearchData?.lineOfBusiness})
    };

    const searchByGrievanceType = (event : any) => {
        event?.preventDefault();
        dispatch(policyDetailsSearchApi(storeSearchData, searchValue, grievanceType, selectedApplication))
        dispatch(getGrievanceDescriptionsApi(mapGrievanceTypeMaster(grievanceType)))
        setSearchClicked(true);
        mapLOBMaster(storeSearchData?.lineOfBusiness) !== LINE_OF_BUSINESS.PMFBY && setValue('policyNumber', '');
        setValue('claimId', '');
        setValue('crop', '');
        setValue('product', '');
        setValue('season', '');
        setValue('year', '');
        setValue('typeOfGrievanceDescription', '')
        errors['policyNumber'] = undefined;
        setCropPopulated(false);
        setProductPopulated(false);
        setSeasonPopulated(false);
        setYearPopulated(false);
    }

    useEffect(()=>{
        if(storePolicyDetailsSearchData?.statusId === 200) {
            if(storePolicyDetailsSearchData?.data?.length > 0){
                switch(grievanceType) {
                    case 'Claim':
                        if(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                            setColumnHeaders(CLAIM_DETAILS_HEADERS)
                        }
                        else if(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY || mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS){
                            setColumnHeaders(PMFBY_CLAIM_DETAILS_HEADERS)
                        }
                        setShowPolicyDetails(false)
                        break;
                    case 'Proposal Related':
                        setColumnHeaders(PROPOSAL_DETAILS_HEADERS)
                        setShowPolicyDetails(false)
                        break;
                    default:
                        setColumnHeaders(POLICY_DETAILS_HEADERS)
                        setShowPolicyDetails(false)
                }
                setShowTable(true)
            }
            else{
                toast.error('No results found');
                setShowTable(false)
                setShowPolicyDetails(true)
            }
        } else if(storePolicyDetailsSearchData?.statusId === 500){
            toast.error('No results found');
            setShowTable(false)
            setShowPolicyDetails(true)
        }
    },[storePolicyDetailsSearchData])

    const [isInitValPopulated, setIsInitValPopulated ] = useState(false);

    useEffect(()=>{
        if(!isInitValPopulated){
            if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchPolicy?.length > 0){
                customerData[0]?.customerName && setValue('name',customerData[0]?.customerName);
                customerData[0]?.mobileNumber && setValue('mobileNumber',customerData[0]?.mobileNumber);
                if(customerData[0]?.customerName.length > 0) setIsNameEditable(false);
                if(customerData[0]?.mobileNumber.length > 0) setIsMobileNumberEditable(false);
                (customerData[0]?.pincode || customerData[0]?.state || customerData[0]?.city) && setPincodePopulated(true);
                setValue('policyNumber',storeSearchData?.searchPolicy);
            }
            else if(Object.keys(selectedApplication).length > 0){
                selectedApplication?.customerName && setValue('name',selectedApplication?.customerName);
                selectedApplication?.mobileNumber && setValue('mobileNumber',selectedApplication?.mobileNumber);
                if(selectedApplication?.customerName.length > 0) setIsNameEditable(false);
                if(selectedApplication?.mobileNumber.length > 0) setIsMobileNumberEditable(false);
                (selectedApplication?.pincode || selectedApplication?.state || selectedApplication?.city) && setPincodePopulated(true);
                if (checkNullValue(selectedApplication?.applicationId) != 'N/A' && mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY){
                    setValue('applicationNumber',selectedApplication?.applicationId)
                    setValue('policyNumber',selectedApplication?.policyNo ? selectedApplication?.policyNo : selectedApplication?.applicationId?.slice(0,19))
                }
                else if (checkNullValue(selectedApplication?.applicationId) != 'N/A' && mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS){
                    setValue('applicationNumber',selectedApplication?.applicationId)
                    setValue('policyNumber',selectedApplication?.policyNo)
                }
                else if (checkNullValue(selectedApplication?.applicationId) != 'N/A' && mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                    setValue('policyNumber',selectedApplication?.applicationId)
                }
            }
            else if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchApplication?.length > 0){
                setValue('applicationNumber',storeSearchData?.searchApplication)
            }
            else if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchPMFBYPolicy?.length > 0){
                setValue('policyNumber',storeSearchData?.searchPMFBYPolicy)
            }
            else if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchRWBCISApplication?.length > 0){
                setValue('applicationNumber',storeSearchData?.searchRWBCISApplication)
            }
            else if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchRWBCISPolicy?.length > 0){
                setValue('policyNumber',storeSearchData?.searchRWBCISPolicy)
            }
        }
        setIsInitValPopulated(true);
    },[selectedApplication, storeSearchData, customerData, isInitValPopulated])


    useEffect(()=>{
        if(pincodePopulated){
            if(Object.keys(storeSearchData).length > 0 && storeSearchData?.searchPolicy?.length > 0){
                setValue('pincode',customerData[0]?.pincode)
                setValue('city',customerData[0]?.city)
                setValue('state',customerData[0]?.state)
            }
            else if (Object.keys(selectedApplication).length > 0) {
                setValue('pincode',selectedApplication?.pincode)
                setValue('city',selectedApplication?.city)
                setValue('state',selectedApplication?.state)
            }
        }
    },[pincodePopulated])

    useEffect(()=>{
        if(Object.keys(storeSearchData).length > 0){
            if(storeSearchData?.searchPolicy?.length > 0){
                setSearchValue(storeSearchData?.searchPolicy)
            } else if(storeSearchData?.searchApplication?.length > 0){
                setSearchValue(storeSearchData?.searchApplication)
            } else if(Object.keys(selectedApplication)?.length > 0){
                if((mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY || mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS) && checkNullValue(selectedApplication?.applicationId) != 'N/A'){
                    setSearchValue(selectedApplication?.applicationId)
                }
                else if (mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL){
                    if(checkNullValue(selectedApplication?.applicationId) != 'N/A'){
                        setSearchValue(selectedApplication?.applicationId)
                    }
                    else if(storeSearchData?.searchMobile?.length > 0){
                        setSearchValue(storeSearchData?.searchMobile)
                    }
                }
            } else if(storeSearchData?.searchMobile?.length > 0){
                setSearchValue(storeSearchData?.searchMobile)
            } else if(storeSearchData?.searchPMFBYPolicy?.length > 0){
                setSearchValue(storeSearchData?.searchPMFBYPolicy)
            } else if(storeSearchData?.searchRWBCISPolicy?.length > 0){
                setSearchValue(storeSearchData?.searchRWBCISPolicy)
            } else if(storeSearchData?.searchRWBCISApplication?.length > 0){
                setSearchValue(storeSearchData?.searchRWBCISApplication)
            }
        }
    },[storeSearchData, selectedApplication])

    
    const mode = watch('complaintMode');
    const source = watch('complaintSource');
    const department = watch('department');
    const requestype= watch('typeOfRequest')
    const spoc = watch('spoc');


    useEffect(()=>{
        setValue('complaintMode','To Be Assigned')
        setValue('complaintSource','To Be Assigned')
        setValue('department','To Be Assigned')
    },[])

    useEffect(()=>{
        if(searchClicked){
            setTimeout(()=>{
                setSearchClicked(false)
            },2000)
        }
    },[searchClicked])

    useEffect(() => {
        setSpocList([])
        if(department && mapMasters(department, departmentData) != 14){
            dispatch(getAllUsersByDepartment(department));
        }
    },[department])

    useEffect(() => {
        setValue('typeOfGrievanceDescription', '')
    }, [requestype])

    useEffect(() => {
        if(storeUserListByDepartment?.length > 0){
            let list: any = [];
            storeUserListByDepartment.map((user: any, i: number) => {
            list.push({value: i, label: `${user.firstName} ${user.lastName ? user.lastName : ''}`})
            })
            setSpocList(list);
        }
    },[storeUserListByDepartment])

    const handleChange = (event: any, label: any) => {
        let value = event.target.value;
        if (value.startsWith(' ')) {
            value = value.trimStart();
        }
        setValue(label, value, { shouldValidate: true })
    }

    useEffect(() => {
        let filteredDepartmentData = departmentData.filter((department: any) => 
        (department.label !== 'Super Admin' && department.label !== 'PMFBY' && checkNullValue(department?.lobId) !== 'N/A') || (department?.label == 'GRO')
        );
        filteredDepartmentData = filteredDepartmentData.filter((department: any) => {
          if (mapLOBMaster(storeSearchData?.lineOfBusiness) === LINE_OF_BUSINESS.TO_BE_ASSIGNED) {
              return true;
          } else if((department?.label == 'GRO')) {
              return department;
          } else {
              return department?.lobId === mapLOBMaster(storeSearchData?.lineOfBusiness);
          }
        });
      
        if (user.roleId === ROLE_ID.GRO || user.roleId === ROLE_ID.AGENT || user.roleId === ROLE_ID.SUPER_ADMIN) {
            setDepartmentList(filteredDepartmentData);
        } else {
            filteredDepartmentData = filteredDepartmentData?.filter((department: any) => {
                return user?.roleName?.includes(department?.label) || department?.label === 'GRO'
            })
            setDepartmentList(filteredDepartmentData);
        }
      }, [user, departmentData, storeSearchData]); 

    return (
        <Modal isOpen={openModal} toggle={toggle} centered={true} size='lg' backdrop={'static'} className="modal-size-custom2">
            <ModalHeader toggle={toggle} close={closeBtn}>Create New Grievance</ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
                <ModalBody>
                    {grievanceTypeSearch && 
                        <>
                            <Row>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Customer Name"
                                        changeFun={onChangeInput}
                                        valueName={'name'}
                                        register={register('name', { pattern: /^[a-zA-Z .]*$/i })}
                                        errors={errors}
                                        formValue={getValues('name')}
                                        required={true}
                                        readOnly={!isNameEditable}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Mobile Number"
                                        changeFun={onChangeInput}
                                        valueName={'mobileNumber'}
                                        register={register('mobileNumber')}
                                        maxLength={10}
                                        errors={errors}
                                        formValue={getValues('mobileNumber')}
                                        required={true}
                                        readOnly={!isMobileNumberEditable}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Email ID"
                                        changeFun={onChangeInput}
                                        valueName={'emailId'}
                                        register={register('emailId', { pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i })}
                                        errors={errors}
                                        formValue={getValues('emailId')}
                                        required={false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Pincode"
                                        changeFun={onChangeInput}
                                        valueName={'pincode'}
                                        register={register('pincode', { pattern: /^[0-9]{6}$/i })}
                                        maxLength={6}
                                        errors={errors}
                                        formValue={getValues('pincode')}
                                        required={false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    {pincode?.length === 6 ?
                                        <TextInput
                                            label="State"
                                            changeFun={onChangeInput}
                                            valueName={'state'}
                                            register={register('state')}
                                            errors={errors}
                                            formValue={getValues('state')}
                                            readOnly={true}
                                            required={false}
                                        />
                                        :
                                        <SelectInput
                                            label="State"
                                            changeFun={onChangeInput}
                                            formValue={getValues('state')}
                                            valueName={'state'}
                                            register={register('state')}
                                            errors={errors}
                                            data={stateData}
                                            required={false}
                                        />
                                    }
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    {pincode?.length === 6 ?
                                        <TextInput
                                            label="City / Town"
                                            changeFun={onChangeInput}
                                            valueName={'city'}
                                            register={register('city')}
                                            errors={errors}
                                            formValue={getValues('city')}
                                            readOnly={true}
                                            required={false}
                                        />
                                        :
                                        <SelectInput
                                            label="City / Town"
                                            changeFun={onChangeInput}
                                            valueName={'city'}
                                            register={register('city')}
                                            formValue={getValues('city')}
                                            errors={errors}
                                            data={districtData}
                                            disabled={getValues('state') ? false : true}
                                            required={false}
                                        />
                                    }
                                </Col>
                                <Col xs={10} md={10} className="mb-3">
                                    <SelectInput
                                        label="Type of Grievance"
                                        changeFun={onChangeInput}
                                        valueName={'grievanceType'}
                                        register={register('grievanceType')}
                                        formValue={getValues('grievanceType')}
                                        errors={errors}
                                        data={grievanceTypeData}
                                        required={true}
                                    />
                                </Col>
                                <Col xs={2} md={2} className="mt-2">
                                    <button 
                                        className='create-grievance' style={{width:'81px'}}  
                                        onClick={searchByGrievanceType}
                                        disabled={getValues('grievanceType')?.length <= 0 || searchClicked  ? true : false}
                                    >
                                        Search
                                    </button>
                                </Col>
                            </Row>
                            {showTable && 
                                <div className="table-container3">
                                    <TableComponent 
                                        columnHeaders={columnHeaders}
                                        data={policyDetails?.data}
                                        onAction={onTableAction}
                                        responsive={false}
                                    />
                                </div>
                            }
                        </>
                    }

                    {showPolicyDetails &&
                        <>
                            <Row>
                                {user?.permissions?.includes('type-of-request-write') && 
                                    <Col xs={6} md={6} className="mb-3">
                                        <SelectInput
                                            label="Type of Request"
                                            data={typeOfRequestData}
                                            valueName={'typeOfRequest'}
                                            register={register('typeOfRequest')}
                                            changeFun={onChangeInput}
                                            required={true}
                                            formValue={getValues('typeOfRequest')}
                                        />
                                    </Col>
                                }
                                {user?.permissions?.includes('type-of-request-write') && 
                                    <Col xs={6} md={6} className="mb-3">
                                        <SelectInput
                                            label="Complaint Description"
                                            data={typeOfGrievanceDescData}
                                            valueName={'typeOfGrievanceDescription'}
                                            register={register('typeOfGrievanceDescription')}
                                            changeFun={onChangeInput}
                                            disabled={!requestype || requestype !== 'Grievance'}
                                            required={requestype === 'Grievance'}
                                            formValue={getValues('typeOfGrievanceDescription')}
                                        />
                                    </Col>
                                }
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Policy ID/ Proposal ID"
                                        changeFun={onChangeInput}
                                        valueName={'policyNumber'}
                                        register={register('policyNumber', { minLength: 5})}
                                        minLength={5}
                                        maxLength={mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY && 19}
                                        errors={errors}
                                        formValue={getValues('policyNumber')}
                                        required={true}
                                    />
                                </Col>
                                {mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY && 
                                    <Col xs={6} md={6} className="mb-3">
                                        <TextInput
                                            label="Application Number"
                                            changeFun={onChangeInput}
                                            valueName={'applicationNumber'}
                                            register={register('applicationNumber', { pattern: /^[0-9,-]*$/i })}
                                            errors={errors}
                                            formValue={getValues('applicationNumber')}
                                            required={false}
                                        />
                                    </Col>
                                }
                                {(mapLOBMaster(storeSearchData?.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS) && 
                                    <Col xs={6} md={6} className="mb-3">
                                        <TextInput
                                            label="Application Number"
                                            changeFun={onChangeInput}
                                            valueName={'applicationNumber'}
                                            register={register('applicationNumber')}
                                            errors={errors}
                                            formValue={getValues('applicationNumber')}
                                            required={false}
                                        />
                                    </Col>
                                }
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Claim ID"
                                        changeFun={onChangeInput}
                                        valueName={'claimId'}
                                        register={register('claimId')}
                                        errors={errors}
                                        formValue={getValues('claimId')}
                                        required={getValues('grievanceType') == 'Claim' ? true : false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                {productPopulated ? 
                                    <TextInput
                                        label="Product Name"
                                        changeFun={onChangeInput}
                                        valueName={'product'}
                                        register={register('product')}
                                        errors={errors}
                                        formValue={getValues('product')}
                                        required={false}
                                        readOnly={productPopulated}
                                    />
                                    :
                                    <SelectInput
                                        label="Product Name"
                                        changeFun={onChangeInput}
                                        valueName={'product'}
                                        register={register('product')}
                                        formValue={getValues('product')}
                                        errors={errors}
                                        data={productData}
                                        required={false}
                                    />
                                }
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                {seasonPopulated ? 
                                    <TextInput
                                        label="Season"
                                        changeFun={onChangeInput}
                                        valueName={'season'}
                                        register={register('season')}
                                        errors={errors}
                                        formValue={getValues('season')}
                                        required={false}
                                        readOnly={seasonPopulated}
                                    />
                                    :
                                    <SelectInput
                                        label="Season"
                                        changeFun={onChangeInput}
                                        valueName={'season'}
                                        register={register('season')}
                                        formValue={getValues('season')}
                                        errors={errors}
                                        data={seasonData}
                                        required={false}
                                    />
                                }
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Crop Name"
                                        changeFun={onChangeInput}
                                        valueName={'crop'}
                                        register={register('crop')}
                                        errors={errors}
                                        formValue={getValues('crop')}
                                        required={false}
                                        readOnly={cropPopulated}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                {yearPopulated ? 
                                    <TextInput
                                        label="Year"
                                        changeFun={onChangeInput}
                                        valueName={'year'}
                                        register={register('year')}
                                        errors={errors}
                                        formValue={getValues('year')}
                                        required={false}
                                        readOnly={yearPopulated}
                                    />
                                :
                                    <YearPicker 
                                        changeFun={handleYearChange}
                                        label="Year"
                                        valueName={'year'}
                                        register={register('year')}
                                        errors={errors}
                                        formValue={getValues('year')}
                                        required={false}
                                        readOnly={yearPopulated}
                                    />
                                }
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <SelectInput
                                        label="Department"
                                        changeFun={onChangeInput}
                                        valueName={'department'}
                                        register={register('department')}
                                        formValue={department}
                                        errors={errors}
                                        data={departmentList}
                                        required={false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <SelectInput
                                        label="Source of Complaint"
                                        changeFun={onChangeInput}
                                        valueName={'complaintSource'}
                                        register={register('complaintSource')}
                                        formValue={source}
                                        errors={errors}
                                        data={complaintSourceData}
                                        required={false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <SelectInput
                                        label="Mode of Grievance"
                                        changeFun={onChangeInput}
                                        valueName={'complaintMode'}
                                        register={register('complaintMode')}
                                        formValue={mode}
                                        errors={errors}
                                        data={modeOfComplaintData}
                                        disabled={!source || source === 'To Be Assigned'}
                                        required={false}
                                    />
                                </Col>
                                <Col xs={6} md={6} className="mb-3">
                                    <TextInput
                                        label="Reference Number"
                                        changeFun={onChangeInput}
                                        valueName={'refno'}
                                        register={register('refno')}
                                        errors={errors}
                                        maxLength={50}
                                        formValue={getValues('refno')}
                                        required={false}
                                    />
                                </Col>
                                {user?.permissions?.includes('assign-spoc') && 
                                    <Col xs={6} md={6} className="mb-3">
                                        <SelectInput
                                            label="SPOC"
                                            data={spocList}
                                            valueName={'spoc'}
                                            register={register('spoc')}
                                            changeFun={onChangeInput}
                                            formValue={spoc}
                                            disabled={!department || mapMasters(department, departmentData) === 14}
                                        />
                                    </Col>
                                }
                            </Row>
                            <Row>
                                <Col xs={6} md={6} className="mb-3">
                                    <LabelField name='Grievance Intimation Date'></LabelField>
                                    <Input
                                        type="date"
                                        max={getCurrentDate()}
                                        min={MIN_DATE_INTIMATION}
                                        {...register("intimationDate")}
                                        onChange={(e) => { onChangeInput('intimationDate', e.target.value) }}
                                        style={{ maxWidth: '95%', fontSize: '13px' }}
                                        value={getValues('intimationDate')}
                                    />
                                </Col>
                                <Col xs={6} md={3} className="mb-3">
                                    <LabelField name='Time' required={getValues('intimationDate')?.length > 0}></LabelField>
                                    <Input
                                        type="time"
                                        {...register("intimationTime")}
                                        onChange={handleTimeChange}
                                        style={{ maxWidth: '95%', fontSize: '13px' }}
                                        disabled={!getValues('intimationDate')}
                                        value={getValues('intimationTime')}
                                        required={getValues('intimationDate')?.length > 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} md={6} className="mb-3">                                                                
                                    <TextAreaInput
                                        label={'Enter Description'} 
                                        minrows={2}
                                        maxrows={2}
                                        required={true}
                                        changeFun={onChangeInput} 
                                        register={register('description', {required : 'Description is required'})}
                                        readOnly={false} 
                                        placeholder={'Enter Description'} 
                                        valueName={'description'}
                                        formValue={getValues('description')}
                                        errors={errors}
                                        style={{marginLeft: 0, width: '95%'}}
                                    />
                                </Col>
                                {user?.permissions?.includes('resolution-remarks') && 
                                    <Col xs={6} md={6} className="mb-3" style={{ marginTop: '1.5%' }}>
                                        <TextAreaInput
                                            label={'Remarks, if any'} 
                                            minrows={1.5} 
                                            maxrows={2}
                                            changeFun={onChangeInput} 
                                            register={register('remarks')}
                                            readOnly={false} 
                                            placeholder={'Remarks'} 
                                            valueName={'remarks'}
                                            formValue={getValues('remarks')}
                                            errors={errors}
                                            style={{marginLeft: 0, width: '95%'}}
                                        />
                                    </Col>
                                }
                                <Col xs={6} md={7} className="mb-3">

                                    <LabelField
                                        name="Upload Files"
                                        required={false}
                                    />

                                    <Input
                                        type="file"
                                        id="fileUpload"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.pdf,.msg,.eml,.doc,.docx,.xls,.xlsx"
                                        onChange={setFile}
                                        hidden
                                    />

                                    <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={() =>
                                        document.getElementById('fileUpload')?.click()
                                        }
                                    >
                                        Choose Files
                                    </Button>

                                    {/*FILE LIST */}
                                    {image.length > 0 && (
                                        <div
                                        className="mt-3 border rounded p-2 bg-light overflow-auto"
                                        style={{ maxHeight: '150px' }}
                                        >
                                        {image.map((file, index) => (
                                            <div
                                            key={index}
                                            className="d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-1 bg-white"
                                            style={{ fontSize: '13px' }}
                                            >
                                            <span
                                                className="text-truncate"
                                                style={{ maxWidth: '85%' }}
                                            >
                                                {file.imageName}
                                            </span>

                                            <Button
                                                close
                                                aria-label="Remove file"
                                                className="bg-danger rounded-circle p-1"
                                                onClick={() =>
                                                setImage(prev =>
                                                    prev.filter((_, i) => i !== index)
                                                )
                                                }
                                            />
                                            </div>
                                        ))}
                                        </div>
                                    )}

                                    <Label className="d-flex error-msg">
                                        *Maximum file size supported: {MAX_ATTACHMENT_SIZE}
                                    </Label>

                                </Col>
                            </Row>
                        </>
                    }
                </ModalBody>
                <ModalFooter>
                    {!showPolicyDetails ?
                        <Button 
                            onClick={() => { toggle(); props.setFlag(false) }} 
                            className="resetButton" 
                            style={{ width: '91px' }}
                        >
                            Close
                        </Button>
                        :
                        <>
                            <Button 
                                type='submit' 
                                className="button" 
                                style={{ width: '91px' }}
                            >
                                Submit
                            </Button>{' '}
                            <Button 
                                onClick={() => { toggle(); props.setFlag(false) }} 
                                className="resetButton" 
                                style={{ width: '91px' }}
                            >
                                Cancel
                            </Button>
                        </>
                    }
                </ModalFooter>
            </form>
        </Modal>
    );
}


export default NewGrievance;